"use strict";

var $body = $('body');
var $window = $(window);
var windowHt = $window.outerHeight();
var $app = $('.app');
var $header = $('.app-header');
var $footer = $('.app-footer');
var $nav = $('.app-header__gnb');
var $article = $('.app-article');
var $tab = $('.app-tab--links');
var $search = $('.app-search');
var $select = $('select');
var $txtarea = $('textarea');
var $file = $('input[type="file"]');
var $swiper = $('.swiper-container');
var $datepicker = $('.datepicker');
$(function () {
  mediaFooter();
  main.set();
  utils.set();
  files.add();
  $(window).on('scroll', function () {
    var st = $window.scrollTop();
    var sb = st + $window.height();
    var mainChk = $app.hasClass('pg-main');
    var subChk = $app.hasClass('pg-sub');
    if (mainChk) main.header(st);else if (subChk) layout.subtit(sb);
    console.log(st);
  }).on('resize', function () {
    var st = $window.scrollTop();
    var sb = st + $window.height();
    var subChk = $app.hasClass('pg-sub');
    var modeChk = $search.hasClass('is-fixed');
    if (subChk) {
      layout.subtit(sb);
      if ($window.width() > 768 && modeChk) {
        $search.removeClass('is-fixed');
        $header.find('.app-header__util').removeClass('is-sub-mode');
      }
    } else {
      // skrollr set & destroy
      if ($window.width() < 1200) {
        skrollr.init().destroy();
      } else {
        skrollr.init({
          forceHiehgt: false
        });
      }
    }
  }).on('load', function () {
    // skrollr destroy
    var subChk = $app.hasClass('pg-sub');
    if ($window.width() < 1200 && !subChk) {
      skrollr.init().destroy();
    }
    if (subChk) {
      var $progress = $('.step-progressbar');
      if ($progress.length > 0) {
        $app.find('.app-content').addClass('pg-step');
        setTimeout(function () {
          $app.find('.app-content').addClass('is-motion');
        }, 100);
        clearTimeout();
      }
    }
  });
  $(document).on('click', '.dropdown-trigger', function (e) {
    dropdownPosY = e.target.getBoundingClientRect().top;
    var t = $(this).parents('.form-dropdown');
    t.hasClass('is-active') ? util_dropdown.close($(this)) : util_dropdown.open($(this));
  }).on('click', '.dropdown-list button', function (e) {
    util_dropdown.select($(this));
    var t = $(this).parents('.form-dropdown');
    var v = $(this).data('option');
    if (v !== '') t.addClass('is-selected');else t.removeClass('is-selected');
    // 연결값
    var linkedChk = $(this).closest('.form-dropdown').hasClass('form-linked');
    var linkedName = $(this).closest('.form-dropdown').data('linked-name');
    var $linkedTarget = $(this).closest('.form-box').find('.form-linked__target[data-linked-name="' + linkedName + '"]');
    if (linkedChk && v == 'y') {
      $linkedTarget.addClass('is-active');
    } else {
      $linkedTarget.removeClass('is-active');
    }
  }).on('click', '.dropdown-list a', function (e) {
    util_dropdown.close($(this));
  });
});
var main = {
  set: function set() {
    var mainChk = $app.hasClass('pg-main');
    if (mainChk) {
      main.video();
      this.swiper();
      this.spy();
      this.faq();
      $window.on('load', function () {
        main.mainSkrollr();
      }).on('resize', function () {
        main.mainSkrollr();
      });
    }
  },
  header: function header(scrolltop) {
    if (scrolltop > 100) $header.addClass('is-bg');else $header.removeClass('is-bg');
  },
  video: function video() {
    var viduslVideo = document.getElementById('video1');
    viduslVideo.addEventListener('suspend', function () {
      if (viduslVideo.paused) {
        viduslVideo.play();
      }
    });
  },
  swiper: function swiper() {
    // flow swiper
    $swiper.each(function (idx, reverse) {
      var $this = $(this);
      var flowType = $this.is('[data-type]');
      if (flowType) {
        var type = $this.data('type');
        $this.addClass('flowswiper' + idx);
        if (type == 'ltr') {
          reverse = true;
        } else {
          reverse = false;
        }
        ;
        var flowSwiper = new Swiper('.flowswiper' + idx, {
          slidesPerView: 'auto',
          freeMode: true,
          autoplay: {
            delay: 0,
            stopOnLastSlide: false,
            disableOnInteraction: true,
            reverseDirection: reverse
          },
          speed: 8000,
          loop: true,
          touchRatio: 0
        });
      }
    });

    // mobile swiper
    var winWidth = $window.width();
    var mobileSwiper = undefined;
    function mobileSwiperInit() {
      if (winWidth < 768 && mobileSwiper == undefined) {
        mobileSwiper = new Swiper('.m-swiper', {
          slidesPerView: 'auto',
          spaceBetween: 10,
          simulateTouch: true,
          loop: false
        });
      } else if (winWidth >= 768 && mobileSwiper != undefined) {
        mobileSwiper.destroy();
        mobileSwiper = undefined;
      }
    }
    mobileSwiperInit();
    $(window).on('resize', function () {
      winWidth = $(window).width();
      mobileSwiperInit();
    });
  },
  mainSkrollr: function mainSkrollr() {
    if ($window.width() < 1200) {
      skrollr.init().destroy();
    } else {
      var $skrollrTarget = $('.flow-text');
      var targetPos = Math.floor($skrollrTarget.offset().top);
      var startPos = 'data-' + (targetPos - 700) + '-start';
      var endPos = 'data-' + (targetPos + 300) + '-start';
      $skrollrTarget.attr(startPos, 'transform:translateX(-20px)').attr(endPos, 'transform:translateX(-400px)');
      skrollr.init({
        forceHiehgt: false
      });
    }
  },
  spy: function spy() {
    $nav.on('click', 'a', function () {
      var navLength = $nav.find('.app-header__gnb-item').length;
      var navIdx = $(this).parent().index();
      if (navIdx + 1 == navLength) navIdx = navLength;
      var targetPos = $article.eq(navIdx + 1).offset().top - $header.height();
      $('body, html').stop().animate({
        scrollTop: targetPos
      });
    });
  },
  faq: function faq() {
    $('button.question').each(function () {
      var $this = $(this);
      var $onoffTarget = $this.parent('.faq-list__item');
      $(this).on('click', function () {
        $onoffTarget.toggleClass('is-active').siblings().removeClass('is-active');
      });
    });
  }
};
var layout = {
  subtit: function subtit(sb) {
    var $moveTarget = $('.app-pg__tit-content');
    var $limitTarget = $moveTarget.closest('.layout-grid');
    var limit_pos = $footer.offset().top;
    var target_pos = limit_pos - $window.height();
    var setPos = $limitTarget.height() > $window.height();
    $moveTarget.css('top', 'auto').removeClass('is-flow');
    if (setPos) {
      if (sb > limit_pos) {
        $moveTarget.css('top', target_pos).addClass('is-flow');
      } else {
        $moveTarget.css('top', 'auto').removeClass('is-flow');
      }
    }
  }
};
var utils = {
  set: function set() {
    this.nav();
    this.datepicker();
    this.form();
    this.search();
  },
  nav: function nav() {
    $header.on('click', '.app-header__menu-btn', function () {
      $(this).closest($header).toggleClass('is-active');
      $body.toggleClass('is-hidden');
    }).on('click', '.app-header__gnb-item a', function () {
      $body.removeClass('is-hidden');
      $header.removeClass('is-active');
    });
  },
  datepicker: function datepicker() {
    $.datepicker.setDefaults({
      closeText: "닫기",
      prevText: "이전달",
      nextText: "다음달",
      currentText: "오늘",
      monthNames: ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"],
      monthNamesShort: ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"],
      dayNames: ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"],
      dayNamesShort: ["일", "월", "화", "수", "목", "금", "토"],
      dayNamesMin: ["일", "월", "화", "수", "목", "금", "토"],
      weekHeader: "주",
      dateFormat: "yy.m.d",
      // 날짜형태 예)yy년 m월 d일
      firstDay: 0,
      isRTL: false,
      showMonthAfterYear: true,
      yearSuffix: "년",
      showButtonPanel: true
    });
    if ($datepicker) {
      if ($datepicker.attr('readonly')) {
        $(this).datepicker('disable').removeAttr('disabled');
      } else {
        $datepicker.datepicker({
          minDate: 0
        });
      }
    }
  },
  form: function form() {
    $('.form-text input').on('focus', function () {
      $(this).parent().addClass('is-active');
    }).on('blur', function () {
      var $thsVal = $(this).val();
      if ($thsVal.length != 0) {
        $(this).parent().addClass('is-active');
      } else {
        $(this).parent().removeClass('is-active');
      }
    });
    $('.agree-all__group').on('change', 'input', function () {
      var $this = $(this);
      var $thisGroup = $this.closest('.agree-all__group');
      var isController = $this.hasClass('ctrl__agree-all');
      var isChecked = $this.is(':checked');
      var $targetYes = $thisGroup.find('input[data-val="yes"]');
      var $targetNo = $thisGroup.find('input[data-val="no"]');
      if (isController) {
        if (isChecked) {
          $targetYes.prop('checked', true);
        } else {
          $targetNo.prop('checked', true);
        }
      } else {
        var chchedLength = $thisGroup.find('input[data-val="yes"]:checked').length;
        if ($targetYes.length != chchedLength) {
          $thisGroup.find('.ctrl__agree-all').prop('checked', false);
        } else {
          $thisGroup.find('.ctrl__agree-all').prop('checked', true);
        }
      }
    });
    $('.total-checkbox input').on('change', function () {
      var isChecked = $(this).is(':checked');
      var $targetYes = $(this).closest('.total-checkbox__group').find('input[data-val="yes"]');
      var $targetNo = $(this).closest('.total-checkbox__group').find('input[data-val="no"]');
      if (isChecked) {
        $targetYes.prop('checked', true);
        console.log($targetYes.length);
      } else {
        $targetNo.prop('checked', true);
        console.log($targetNo.length);
      }
    });
  },
  search: function search() {
    $header.on('click', '.app-header__search-btn', function () {
      $(this).closest('.app-header__util').toggleClass('is-sub-mode');
      $search.toggleClass('is-fixed');
      if (!$search.hasClass('is-fixed')) $search.find('input[type="text"]').val('');
    });
  }
};

// custom selectbox
var dropdownPosY;
var util_dropdown = {
  open: function open(t) {
    var e = t.parents('.form-dropdown');
    if (0 < e.find('select').length && this.bind(t), e.addClass('is-active'), 'number' == typeof dropdownPosY) {
      var _e = t.siblings('.dropdown-list');
      var n = _e.outerHeight();
      _e.css({
        width: t.outerWidth() + 'px'
      }), windowHt - dropdownPosY - 50 < n ? _e.addClass('is-upside') : _e.removeClass('is-upside');
    }
  },
  close: function close(e) {
    e.parents('.form-dropdown').removeClass('is-active');
  },
  bind: function bind(e) {
    var t = e.parents('.form-dropdown');
    t.find('.dropdown-list').remove(), t.find('.form-inner').append('<ul class="dropdown-list"></ul>'), t.find('select').children('option').each(function () {
      t.find('.dropdown-list').append("<li><button type=\"button\" data-option=\"".concat($(this).val(), "\"><span>").concat($(this).text(), "</span></button></li>"));
    });
  },
  select: function select(e) {
    var t = e.parents('.form-dropdown');
    var n = e.text(),
      e = e.data('option');
    t.removeClass('is-active').find('.dropdown-trigger span').text(n), t.find('select').val(e), t.find('select').trigger('change');
  }
};

// file upload
var fileNo = 0;
var filesArr = new Array();
var files = {
  add: function add() {
    $file.on('change', function () {
      var _this = this;
      var $this = $(this);
      var $upload = $this.closest('.form-file');
      $upload.addClass('is-changed');
      var maxFileCnt = 5; // 첨부파일 최대 개수
      var attFileCnt = $upload.find('.file-list__item').length; // 기존 추가된 첨부파일 개수
      var remainFileCnt = maxFileCnt - attFileCnt; // 추가로 첨부가능한 개수
      var curFileCnt = this.files.length; // 현재 선택된 첨부파일 개수
      // 첨부파일 개수 확인
      if (curFileCnt > remainFileCnt) {
        alert("첨부파일은 최대 " + maxFileCnt + "개 까지 첨부 가능합니다.");
      }
      var _loop = function _loop() {
        var file = _this.files[i];
        // 파일 배열에 담기
        reader = new FileReader();
        reader.onload = function () {
          filesArr.push(file);
        };
        reader.readAsDataURL(file);

        // 목록 추가
        var htmlData = '';
        htmlData += '<li id="file' + fileNo + '" class="file-list__item">';
        htmlData += '   <span class="file-name">' + file.name + ' (' + fnGetFileSize(file.size) + ')</span>';
        htmlData += '   <button class="delete-file--button" onclick="files.delete(' + fileNo + ');"><i class="icon-common-delete"></i></button>';
        htmlData += '</li>';
        $this.closest('.form-file').find('.file-list').append(htmlData);
        fileNo++;
      };
      for (var i = 0; i < Math.min(curFileCnt, remainFileCnt); i++) {
        var reader;
        _loop();
      }
      // 초기화
      $this.value = "";
      // fileSize
      function fnGetFileSize(filesize) {
        var text = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'];
        var e = Math.floor(Math.log(filesize) / Math.log(1024));
        return (filesize / Math.pow(1024, e)).toFixed(2) + " " + text[e];
      }
      ;
    });
  },
  "delete": function _delete(num) {
    $("#file" + num).remove();
    filesArr[num].deleted = true;
    var deletedLength = filesArr.filter(function (el) {
      return el.deleted === true;
    }).length;
    if (filesArr.length == deletedLength) {
      // 초기화
      filesArr = [];
      fileNo = 0;
      $('.form-file.is-changed').removeClass('is-changed');
    }
  }
  // form 전송시 deleted 없는 배열 값만 추출하여 전송.
};

// *** KBS 미디어 Footer Control
var mediaFooter = function mediaFooter() {
  var footer_loaded = true; //푸터 로딩여부
  $('.footer-service, .footer-family').on('click', function () {
    //푸터 메뉴 열기
    if ($(this).find('.select-ul').attr('class').indexOf('on') > -1) {
      $(this).find('.select-ul').removeClass('on');
      $(this).find('.footer-toggle').addClass('collapsed');
    } else {
      if ($(this).attr('class') === 'footer-family') {
        $('.footer-service').find('.select-ul').removeClass('on');
        $('.footer-service').find('.footer-toggle').addClass('collapsed');
      }
      $(this).find('.select-ul').addClass('on');
      $(this).find('.footer-toggle').removeClass('collapsed');
    }
  });
  $(window).on('click', function (e) {
    //바탕화면을 눌렀을때 열린 메뉴 닫기
    if ($(e.target).parents('.footer-service').length > 0 || $(e.target).parents('.footer-family').length > 0) {} else {
      $('.footer-service ul, .footer-family ul').removeClass('on');
      $('.footer-toggle').addClass('collapsed');
    }
  });
};